import { Reveal, SectionHeading } from "@/components/Reveal";
import { ShieldCheck, Zap, Leaf, Timer, Crosshair, PiggyBank } from "lucide-react";

const CARDS = [
  {
    icon: Zap,
    badge: "Massimo Rendimento",
    title: "Fino al +35% di resa energetica",
    desc: "Polvere, smog, guano e detriti riducono drasticamente la capacità di produzione dei tuoi pannelli. Il lavaggio con drone li rimuove in modo preciso e non invasivo, riportando l'impianto al massimo dell'efficienza.",
    span: "md:col-span-7",
  },
  {
    icon: ShieldCheck,
    badge: "100% Sicuro",
    title: "Sicurezza totale",
    desc: "Operazioni senza rischi per il personale e senza ponteggi: nessuno sale sul tuo tetto, nessuna micro-frattura ai pannelli.",
    span: "md:col-span-5",
  },
  {
    icon: Timer,
    badge: "Rapidità",
    title: "Efficienza e velocità",
    desc: "Interventi molto più rapidi dei metodi tradizionali, con tempi di fermo impianto ridotti al minimo.",
    span: "md:col-span-5",
  },
  {
    icon: Crosshair,
    badge: "Monitoraggio",
    title: "Precisione e controllo",
    desc: "Ispezioni dettagliate e rapporti precisi sullo stato dell'impianto: rileviamo tempestivamente ogni problematica.",
    span: "md:col-span-7",
  },
  {
    icon: PiggyBank,
    badge: "Convenienza",
    title: "Risparmio di costi",
    desc: "L'automazione del processo abbatte i costi operativi: niente piattaforme, impalcature o lunghe ore di manodopera.",
    span: "md:col-span-6",
  },
  {
    icon: Leaf,
    badge: "Zero Chimici",
    title: "Sostenibilità",
    desc: "Solo acqua osmotizzata pura e tecnologie ecologiche: impatto ambientale ridotto, niente detergenti aggressivi.",
    span: "md:col-span-6",
  },
];

export function Vantaggi() {
  return (
    <section id="vantaggi" className="py-24 sm:py-32 bg-[#0D0E13] border-y border-white/5" data-testid="vantaggi-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="Perché Pulire l'Impianto"
          title={
            <>
              I vantaggi della pulizia <span className="fire-text">con drone</span>
            </>
          }
          sub="I tuoi pannelli solari meritano di funzionare al massimo dell'efficienza. Ecco perché la manutenzione con drone è il modo più intelligente di mantenerli puliti e produttivi."
        />

        <div className="grid md:grid-cols-12 gap-6 mt-16">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={(i % 2) * 0.08} className={c.span}>
              <div
                className="card-glow bg-[#13141B] border border-white/10 rounded-3xl p-8 h-full flex flex-col justify-between min-h-[210px]"
                data-testid={`advantage-card-${i}`}
              >
                <div className="flex items-start justify-between gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center">
                    <c.icon size={22} className="text-orange-500" />
                  </div>
                  <span className="font-mono-adj text-[10px] uppercase tracking-[0.2em] text-orange-400 border border-orange-500/30 rounded-full px-3 py-1.5">
                    {c.badge}
                  </span>
                </div>
                <div className="mt-8">
                  <h3 className="font-heading text-xl sm:text-2xl font-bold text-white">{c.title}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed mt-3 max-w-xl">{c.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
